import React from "react";

export interface StatCardProps {
  title: string;
  value: number;
  icon: React.ReactNode; // Accepts React component
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon }) => {
  return (
    <div className="flex items-center justify-between p-4 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-200 border">
      <div className="flex items-center space-x-3">
        <div className="text-3xl text-gray-700">{icon}</div>
        <div>
          <p className="text-sm text-gray-500 font-medium">{title}</p>
          <h3 className="text-xl font-semibold text-gray-800">{value}</h3>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
